import { createContext } from "react";

import { FormTypeEnum } from "@layout/modals/types";

import { AuthorizationFormContextType } from "./types";

const AuthorizationFormContext = createContext<AuthorizationFormContextType>({
  formType: null,
  setFormType: () => {},
  sentContact: null,
  setSentContact: () => {},
  backButtonFormType: FormTypeEnum.Login,
  setBackButtonFormType: () => {},
  formCloseCallback: null,
  setFormCloseCallback: () =>
    () =>
      null,
  sentCodeTimestamp: null,
  setSentCodeTimestamp: () => {},
});

export default AuthorizationFormContext;
